<template>
  <div class="uploading-progress-wrapper">
    <div class="uploading-title">{{ uploadTitle }}</div>
    <div v-if="uploadState.indexOf('loading') > -1" class="uploading">
      <div class="progress-wrapper">
        <el-progress :text-inside="true" :percentage="percentage" color="#df5813" :stroke-width="6" :show-text="false"></el-progress>
      </div>
      <div class="uploading-text">
        正在为您{{ message }}，进度<span>{{ percentage }}%<span v-show="percentage !== 100">...</span></span>
        <div>请勿关闭浏览器或离开页面</div>
      </div>
    </div>
    <div v-else-if="uploadState == 'error'" class="error">
      <div class="uploading-text">
        {{ message }}
        <div class="button" @click="reUpload()">重新上传</div>
      </div>
    </div>
    <div v-else-if="uploadState == 'analysis'" class="analysis">
      <div class="content-icon">
        <div class="column">
          <div class="container animation-5">
            <div class="shape shape1"></div>
            <div class="shape shape2"></div>
            <div class="shape shape3"></div>
            <div class="shape shape4"></div>
          </div>
        </div>
      </div>
      <div class="uploading-text">
        正在解析文件是否规范，资源是否缺失
        <div>请勿关闭浏览器或离开页面</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'uploadProgress',
  props: {
    title: String,
    percentage: {
      default: 0
    },
    uploadState: {
      type: String,
      default: 'loading'
    },
    message: String
  },
  data() {
    return {
      uploadTitle: this.title
    }
  },
  methods: {
    reUpload() {
      this.$emit('updateState', 'ready')
      this.uploadTitle = this.title
    }
  },
  watch: {
    uploadState(val) {
      if (val === 'analysis') {
        this.uploadTitle = '文件解析中'
      } else if (val === 'transform') {
        this.uploadTitle = '文件转换中'
      } else if (val === 'error') {
        this.uploadTitle = '文件解析失败'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.uploading-progress-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .uploading-title {
    color: #df5813;
    margin-bottom: 14px;
    font-weight: bold;
  }
  .progress-wrapper {
    width: 250px;
  }
  .analysis {
    text-align: center;
    .block_1 {
      width: 35px;
      height: 33px;
    }
  }
  .uploading-text {
    margin-top: 14px;
    font-size: 14px;
    text-align: center;
    span {
      color: #df5813;
      padding-left: 8px;
      span {
        padding-left: 0;
      }
    }
    div {
      font-size: 12px;
      color: #999999;
      margin-top: 10px;
    }
    .button {
      background-color: #df5813;
      display: block;
      cursor: pointer;
      color: #ffffff;
      font-size: 14px;
      width: 90px;
      height: 28px;
      line-height: 28px;
      margin: 10px auto;
    }
  }
  .el-message-box {
    .el-message-box__title {
      height: 10px !important;
    }
    .el-message-box__headerbtn {
      top: 10px !important;
    }
  }
  /*转换中图标*/
  .content-icon {
    .column {
      width: 50px;
      height: 50px;
      /* background-color: #040038; */
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
    }

    .container {
      width: 30px;
      height: 30px;
      position: relative;
    }

    .container.animation-5 {
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    .container.animation-5 .shape {
      width: 15px;
      height: 15px;
    }

    .container.animation-6 {
      -webkit-animation: rotation 1s infinite;
      animation: rotation 1s infinite;
    }

    .container.animation-6 .shape {
      width: 12px;
      height: 12px;
      border-radius: 2px;
    }

    .container .shape {
      position: absolute;
      width: 10px;
      height: 10px;
      border-radius: 1px;
    }

    .container .shape.shape1 {
      left: 0;
      background-color: #5c6bc0;
    }

    .container .shape.shape2 {
      right: 0;
      background-color: #8bc34a;
    }

    .container .shape.shape3 {
      bottom: 0;
      background-color: #ffb74d;
    }

    .container .shape.shape4 {
      bottom: 0;
      right: 0;
      background-color: #f44336;
    }

    @-webkit-keyframes rotation {
      from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @keyframes rotation {
      from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    .animation-5 .shape1 {
      animation: animation5shape1 2s ease 0s infinite reverse;
    }

    @-webkit-keyframes animation5shape1 {
      0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
      }
      25% {
        -webkit-transform: translate(0, 15px);
        transform: translate(0, 15px);
      }
      50% {
        -webkit-transform: translate(15px, 15px);
        transform: translate(15px, 15px);
      }
      75% {
        -webkit-transform: translate(15px, 0);
        transform: translate(15px, 0);
      }
    }

    @keyframes animation5shape1 {
      0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
      }
      25% {
        -webkit-transform: translate(0, 15px);
        transform: translate(0, 15px);
      }
      50% {
        -webkit-transform: translate(15px, 15px);
        transform: translate(15px, 15px);
      }
      75% {
        -webkit-transform: translate(15px, 0);
        transform: translate(15px, 0);
      }
    }

    .animation-5 .shape2 {
      animation: animation5shape2 2s ease 0s infinite reverse;
    }

    @-webkit-keyframes animation5shape2 {
      0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
      }
      25% {
        -webkit-transform: translate(-15px, 0);
        transform: translate(-15px, 0);
      }
      50% {
        -webkit-transform: translate(-15px, 15px);
        transform: translate(-15px, 15px);
      }
      75% {
        -webkit-transform: translate(0, 15px);
        transform: translate(0, 15px);
      }
    }

    @keyframes animation5shape2 {
      0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
      }
      25% {
        -webkit-transform: translate(-15px, 0);
        transform: translate(-15px, 0);
      }
      50% {
        -webkit-transform: translate(-15px, 15px);
        transform: translate(-15px, 15px);
      }
      75% {
        -webkit-transform: translate(0, 15px);
        transform: translate(0, 15px);
      }
    }

    .animation-5 .shape3 {
      animation: animation5shape3 2s ease 0s infinite reverse;
    }

    @-webkit-keyframes animation5shape3 {
      0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
      }
      25% {
        -webkit-transform: translate(15px, 0);
        transform: translate(15px, 0);
      }
      50% {
        -webkit-transform: translate(15px, -15px);
        transform: translate(15px, -15px);
      }
      75% {
        -webkit-transform: translate(0, -15px);
        transform: translate(0, -15px);
      }
    }

    @keyframes animation5shape3 {
      0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
      }
      25% {
        -webkit-transform: translate(15px, 0);
        transform: translate(15px, 0);
      }
      50% {
        -webkit-transform: translate(15px, -15px);
        transform: translate(15px, -15px);
      }
      75% {
        -webkit-transform: translate(0, -15px);
        transform: translate(0, -15px);
      }
    }

    .animation-5 .shape4 {
      animation: animation5shape4 2s ease 0s infinite reverse;
    }

    @-webkit-keyframes animation5shape4 {
      0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
      }
      25% {
        -webkit-transform: translate(0, -15px);
        transform: translate(0, -15px);
      }
      50% {
        -webkit-transform: translate(-15px, -15px);
        transform: translate(-15px, -15px);
      }
      75% {
        -webkit-transform: translate(-15px, 0);
        transform: translate(-15px, 0);
      }
    }

    @keyframes animation5shape4 {
      0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
      }
      25% {
        -webkit-transform: translate(0, -15px);
        transform: translate(0, -15px);
      }
      50% {
        -webkit-transform: translate(-15px, -15px);
        transform: translate(-15px, -15px);
      }
      75% {
        -webkit-transform: translate(-15px, 0);
        transform: translate(-15px, 0);
      }
    }
  }
}
</style>
